import { http } from '../../../api'

const settings = {
  namespaced: true,
  state: {
    settingsList: []
  },
  actions: {
    getSettingsList: ({ commit }) => {
      return http.get('/contact').then(res => {
        commit('setSettingsList', res.data.data)
      })
    },
    updateSettings: ({ commit }, params) => {
      return http.post('/contact/' + params.id, params.data).then(res => {
        commit('setSettingsList', res.data.data)
        return res.data.data
      })
    }
  },
  mutations: {
    setSettingsList (state, data) {
      state.settingsList = data
    }
  },
  getters: {
    settingsList: state => state.settingsList
  }
}

export default settings
